import { Component, Input } from '@angular/core';
import { HrBaseElementComponent } from '../hr-base-element/hr-base-element.component';

@Component({
    selector: 'hr-form-textarea',
    templateUrl: './hr-form-textarea.component.html',
})
export class HrFormTextareaComponent extends HrBaseElementComponent {
    @Input() autoResize: boolean;
    @Input() rows: number;
    @Input() cols: number;
}
